// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-input[data-v-456aaa68] {\n  border: 1px solid blue;\n  display: none;\n}\n.count[data-v-456aaa68] {\n  color: var(--Gray-3, #828282);\n  font-family: Outfit;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n.warningText[data-v-456aaa68] {\n  margin: 16px 0;\n  border-radius: 8px;\n  border: 1px solid rgba(26, 123, 238, 0.2);\n  background: #eaefff;\n  width: 100%;\n  line-height: normal;\n  padding: 8px 16px;\n}\n", ""]);
// Exports
module.exports = exports;
